import { render, staticRenderFns } from "./ApiPermissionConfirmDialog.vue?vue&type=template&id=4da6289a&scoped=true"
import script from "./ApiPermissionConfirmDialog.vue?vue&type=script&lang=js"
export * from "./ApiPermissionConfirmDialog.vue?vue&type=script&lang=js"
import style0 from "./ApiPermissionConfirmDialog.vue?vue&type=style&index=0&id=4da6289a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da6289a",
  null
  
)

export default component.exports